/**
 * The first human-readable message in one field of an API error body.
 *
 * DRF answers validation errors as {"field": ["message", ...]} and
 * refusals as {"detail": "message"}. The sign-up handlers assumed the first
 * shape everywhere and indexed [0] into the value, so a refusal such as the
 * regional sign-up halt showed only its first letter. This reads both.
 */
export function firstErrorMessage(value: unknown): string {
  if (Array.isArray(value)) {
    return value.length ? firstErrorMessage(value[0]) : "";
  }
  if (typeof value === "string") return value;
  if (value && typeof value === "object") {
    const inner = Object.values(value as Record<string, unknown>)[0];
    return inner === undefined ? "" : firstErrorMessage(inner);
  }
  return value === undefined || value === null ? "" : String(value);
}
